export default __webpack_public_path__ + "static/media/check.d2fba1e8.svg";